import type { GameState } from './gameState'
import { getFacilityDefinition } from '../data/facilities'
import { PROTOTYPE_REGIONS, type ActiveMajorPowerId } from '../data/regions'

export interface NationPowerStatus {
  used: number
  capacity: number
  available: number
}

export function getNationPowerStatus(
  state: GameState,
  nationId: ActiveMajorPowerId,
): NationPowerStatus {
  let used = 0

  for (const region of PROTOTYPE_REGIONS) {
    if (state.regionControllers[region.id] !== nationId) {
      continue
    }

    for (const facilityId of state.construction.facilities[region.id] ?? []) {
      used += getFacilityDefinition(facilityId).powerDemand
    }
  }

  for (const project of state.construction.queue) {
    if (project.nationId === nationId) {
      used += getFacilityDefinition(project.facilityId).powerDemand
    }
  }

  const capacity = state.nations[nationId].economy.capacity.power

  return {
    used,
    capacity,
    available: capacity - used,
  }
}
